export const PATTERNS = {
  money: /^$|^\d{0,5}(\.\d{0,2})?$/,
  phone: /^$|^\(\d{3}\) \d{3}-\d{4}$/,
  number: /^\d*?$/,
};
